import React, { Suspense } from 'react'

const ResetPasswordPageBase = React.lazy(() => import('./ResetPassword'))

export const ResetPasswordPage = () => (
  <Suspense fallback={null}>
    <ResetPasswordPageBase />
  </Suspense>
)
